import {branch, compose, mapProps, renderComponent} from 'recompose';
import _ from 'lodash';
import Error from 'App/components/Error';
import Loading from 'App/components/Loading';

// https://www.apollographql.com/docs/react/recipes/recompose.html
export const renderWhileLoading = (propName = 'data', component = Loading) =>
  branch(
    props => props[propName] && props[propName].loading,
    renderComponent(component),
  );

export const renderForError = (propName = 'data', component = Error) =>
  compose(
    mapError(propName),
    branch(
      props => props[propName] && props[propName].error,
      renderComponent(component),
    )
  );

// Define an HoC that displays the Loading component instead of the
// wrapped component when props.data.loading is true
const mapError = (propName) => mapProps(
  (props) => {
    const data = props[propName];
    const rest = _.omit(props, [propName]);

    if (props[propName].error) {
      return {
        data,
        message: data.error.message,
        ...rest,
      };
    }

    return {
      data,
      ...rest,
    };
  });

// cobines multiple queries into one
// requires renaming of all queries
export const combineQueries = (suffix='qry_') =>
  (mapProps(
      (ownerProps) => {
        let data = {
          error: false,
          loading: false
        };

        Object.keys(ownerProps).map((key) => {
          if (key.includes(suffix)) {
            const it = ownerProps[key];

            data = {
              ...data,
              key: it,
              error: data.error || it.error,
              loading: data.loading || it.loading
            };
          }
        });

        return {
          ...ownerProps,
          data: data
        }
      }
    )
  );


// WEBPACK FOOTER //
// ./src/util/recompose/graphql.js